// extracted by mini-css-extract-plugin
export default {"skills_section":"AnimatedSkills_skills_section__qjvFI","svg_container":"AnimatedSkills_svg_container__b8a5W"};